import './App.css';
import Component from './components/Component';

function App() {
  return (
    <div className="App">
      <Component />
    </div>
  );
}

export default App;
